export default __webpack_public_path__ + "static/media/val-vesa.0e2f06a0.jpg";